import SCHCTemplatesManageData from './SCHCTemplatesManageData';

export default SCHCTemplatesManageData;
